import { Component, AfterViewInit } from '@angular/core';
declare var window: any;

@Component({
  selector: 'app-support-page',
  templateUrl: './support-page.component.html',
  styleUrls: ['./support-page.component.scss'],
})
export class SupportPageComponent implements AfterViewInit {
  constructor() {}

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }
}
